import { z } from "zod";
import { ChainSchema } from "../chain";
import { DexSchema } from "../pool";
import { UserLevelSchema } from "../user";

export const AppConfigSchema = z.object({
  chains: ChainSchema.array(),
  dexes: DexSchema.array(),
  levels: z.record(z.string(), UserLevelSchema),
});

export type AppConfig = z.infer<typeof AppConfigSchema>;
